export const SERVERMODE = "servermode";
export const CHECK = "check_response"; // 检查客户端
export const LOGIN = "login_response"; // 登录
export const LOGOUT = "logout_response"; // 注销
export const SERVERS = "servers_response"; // 获取能够连接的所有server列表
export const UPLOAD = "upload_response"; // 上传
export const DOWNLOAD = "download_response"; // 下载
export const DOWNLOADTO = "downloadto_response"; // 下载到
export const LS = "list_response"; // 列出当前文件夹下的文件列表
export const MV = "mv"; // 移动
export const RM = "remove_response"; // 删除
export const RN = "rename_response"; // 重命名
export const MKDIR = "create_folder_response"; // 新建文件夹
export const GET_TRANS_COUNT = "get_trans_count_response"; // 获取当前用户正在传输任务数
export const TASK_COUNT = "task_count";
export const START_UPDATE = "start_update_response";
export const UPDATE_CLIENT = "download_update_file_response";
export const DISCONNECT = "disconnect"; // client disconnect form ftp server
export const START = "start"; // 启动
export const RESTART = "restart"; // 重启
export const SHUTDOWN = "shutdown"; // 关闭
export const SESSIONS = "sessions"; // 获取FTP-SERVER的全部会话
export const PERFORMANCE = "performance"; // 获取cpu disk netstat等性能信息
export const LICENSE = "license"; //
export const CREATEURL = "createurl"; // 创建分享连接
export const SETURLCONF = "seturlconf"; // 设置连接权限
export const GETURLINFO = "geturkinfo"; // 获取链接所有信息
export const CHECKURL = "chechurl"; // 检验分享链接是否密码访问
export const CHECKPASSWD = "checkpasswd"; // 检查url密码
export const GET_ERROR_INFO = "get_error_info_response";
export const TIMING_TASK = "timing_task_response"; // 创建同步目录任务
